import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { hideToast } from '@/store/slices/toastSlice';

export function Toast() {
  const dispatch = useAppDispatch();
  const { open, message, severity, duration } = useAppSelector(state => state.toast);

  const handleClose = (_: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    dispatch(hideToast());
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MuiAlert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        elevation={6}
        sx={{ minWidth: 280 }}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
}
